module.exports = __webpack_public_path__ + "static/media/interswitch.606cc124.svg";